import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ComboBoxOption } from "@typings/components/comboBox";
import type { GetIndividualsResponse } from "../type";
import type { Individual } from "@typings/entities/individuals";

export async function searchIndividuals(
  query: string,
  extraParams?: Record<string, string>,
): Promise<ComboBoxOption<Individual>[]> {
  const params = new URLSearchParams();
  const trimmedQuery = query?.trim();

  if (trimmedQuery) {
    params.append("search", trimmedQuery);
  }

  if (extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      params.append(key, value);
    });
  }

  const url = params.toString()
    ? `${apiPaths.individuals.list}?${params.toString()}`
    : apiPaths.individuals.list;

  const response = await apiClient.get<GetIndividualsResponse>(url);

  return response.data.items.map((item) => ({
    label: item.marking ? `${item.ufuName} - ${item.marking}` : item.ufuName,
    value: item.id,
    item,
  }));
}
